/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MobileNotificationPreviewViewModel } from "../types/MobileNotificationPreviewViewModel.ts";
import { eMobileNotificationStatusSchema } from "./eMobileNotificationStatusSchema.ts";

export const mobileNotificationPreviewViewModelSchema = z.object({
  title: z.string().nullish(),
  message: z.string().nullish(),
  classStudentIds: z.array(z.number().int()).nullish(),
  classStudentNames: z.array(z.string()).nullish(),
  allowedEnrollmentStatus: z.array(z.number().int()).nullish(),
  urlExternal: z.string().nullish(),
  scheduledAtUtc: z.string().datetime().nullish(),
  notificationType: z.optional(
    z
      .lazy(() => eMobileNotificationStatusSchema)
      .describe(
        "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
      ),
  ),
}) as unknown as ToZod<MobileNotificationPreviewViewModel>;
